"use client";

import { cn } from "@/lib/utils";
import { normalizeCmsHtml } from "@/lib/cmsHtml";
import React from "react";

interface Footer2Data {
  /** CMS / DB field names */
  gradient_start_color?: string;
  gradient_end_color?: string;
  /** Legacy keys (if any stored JSON used these) */
  background_gradient_from?: string;
  background_gradient_to?: string;
  background_gradient_angle?: number | null;
  copyright_text?: string;
  copyright_text_color?: string;
  status: number;
}

const Footer2: React.FC<{ data: { data?: Footer2Data } }> = ({ data }) => {
  const sectionData = data?.data;

  if (!sectionData?.status) return null;

  const {
    gradient_start_color,
    gradient_end_color,
    background_gradient_from,
    background_gradient_to,
    background_gradient_angle,
    copyright_text = "Copyright 2026 of ATLAS SkillTech University | All Rights Reserved Privacy Policy",
    copyright_text_color = "#FFFFFF",
  } = sectionData;

  const gradientFrom =
    gradient_start_color ?? background_gradient_from ?? "#3C398E";
  const gradientTo =
    gradient_end_color ?? background_gradient_to ?? "#00BFFF";
  const angle = background_gradient_angle ?? 90;

  return (
    <footer className="w-full">
      <div
        className={cn(
          "flex items-center justify-center w-full",
          "px-[60px] py-[12px]",
        )}
        style={{
          backgroundImage: `linear-gradient(${angle}deg, ${gradientFrom}, ${gradientTo})`,
        }}
      >
        <div
          className={cn(
            "text-[12px] sm:text-[14px] lg:text-[16px] font-semibold text-center",
            "leading-[1.5] sm:leading-normal",
            "tracking-[0.12px] sm:tracking-[0.14px] lg:tracking-[0.16px]",
          )}
          style={{
            fontFamily: "var(--font-google-sans)",
            color: copyright_text_color,
          }}
          dangerouslySetInnerHTML={{
            __html: normalizeCmsHtml(copyright_text),
          }}
        />
      </div>
    </footer>
  );
};

export default Footer2;
